export const BASE_DELAY = 20;
export const BULK_REQUEST_LIMIT = 500;
export const DO_NOT_CARE_STAFF = 'DO_NOT_CARE';
export const MAX_STAFF_FILTER_SELECTIONS = 5;
export const AVAILABILITY_PLUGIN_SLOT_ID = 'calendar-availability-slot';
export const STAFF_RESOURCE_ID = '1cd44cf8-756f-41c3-bd90-3e2ffcaf1155';
export const ALL_DAY_MULTI_DAY_EXPERIMENT =
  'specs.bookings.AllDayMultiDayEvents';
export const COLLECT_PARTICIPANT_FORM_EXPERIMENT = 'collectParticipantFormUou';
export const WDS_CALENDAR_WIDGET_SETTINGS_EXPERIMENT =
  'specs.bookings.wdsCalendarWidgetSettings';
export const REQUIRE_VARIANT_CHOICE_ON_BOOKING =
  'requireVariantChoiceOnBooking';
export const MIGRATE_BOOKINGS_THUMBNAIL_TO_WDS =
  'migrateBookingsThumbnailToWDS';
